import { render, staticRenderFns } from "./RmSurveyDialog.vue?vue&type=template&id=1fc2e93a&scoped=true"
import script from "./RmSurveyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmSurveyDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmSurveyDialog.vue?vue&type=style&index=0&id=1fc2e93a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2e93a",
  null
  
)

export default component.exports